module.exports = __webpack_public_path__ + "img/psv-eindhoven.6a9653f8.png";